import {useProduct} from '@salesforce/commerce-sdk-react'
import {getBundleSetInfo, isBundleSet} from '../../../utils/bundle-utils'

const usePdpProduct = (parameters, enabled) => {
    const queryOptions = {
        // Preserve the previous product while a variant or product ID change is loading.
        // This option was moved here from the PDP and still applies to both queries.
        keepPreviousData: true,
    }
    const productQuery = useProduct(
        {parameters},
        // Identify the PDP query for the SSR wrapper. The marker alone does not enable
        // extra passes: the fetched product must also be a fixed or flexible bundle.
        {...queryOptions, enabled, meta: {bundleEditorialPdp: true}},
    )
    const product = productQuery.data
    const bundleInfo = getBundleSetInfo(product)
    const primaryProductId = isBundleSet(product)
        ? bundleInfo?.firstPrimaryProductId || bundleInfo?.primaryProducts?.[0]?.productId
        : null
    // Bundle projections contain pricing/card data, not the full editorial attributes.
    // This query becomes enabled only after the bundle response reveals its primary ID.
    // Ordinary PDPs leave it disabled; their editorial content comes from productQuery.
    const {data: editorialProduct} = useProduct(
        {parameters: {...parameters, id: primaryProductId}},
        {...queryOptions, enabled: !!primaryProductId},
    )

    return {...productQuery, editorialProduct}
}

export default usePdpProduct
